var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveToCloudPubIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 5.407a6.06 6.06 0 00-2.16-3.523A6.34 6.34 0 0010 .5C7.592.5 5.5 1.833 4.458 3.783a5.04 5.04 0 00-3.18 1.588A4.802 4.802 0 000 8.625c0 2.69 2.242 4.875 5 4.875h10.833c2.3 0 4.167-1.82 4.167-4.063 0-2.144-1.708-3.883-3.875-4.03zm-1.958 2.405L10 11.875 5.833 7.812h2.5v-3.25h3.334v3.25h2.5z"
  })));
}
export default SvgSaveToCloudPubIcon;